'use client';

import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import { GoogleAnalytics, sendGTMEvent } from '@next/third-parties/google';
import '@/styles/components/CourseItems.css';
import Link from 'next/link';
import Image from 'next/image';

const CourseItems = () => {
    const handleLearnMoreClick = (title) => {
        sendGTMEvent({
            event: 'button_click',
            category: 'course',
            action: 'learnMore',
            label: title,
        });
    };

    const handleEnrollClick = (title) => {
        sendGTMEvent({
            event: 'button_click',
            category: 'course',
            action: 'enroll',
            label: title,
        });
    };

    const courseItems = [
        {
            img: '/svg/Flag_of_Poland.svg',
            title: 'Польська мова A1 — твій впевнений старт за 1.5 місяці!',
            description:
                'Наш курс A1 — це ідеальний вибір для тих, хто ніколи не вивчав польську або хоче освіжити основи.',
            numberOfLessons: '22',
            duration: '1.5 місяці',
            price: '599 zł',
            link1: '/courses#polish-a1',
            link2: '/contact',
        },
        {
            img: '/svg/Flag_of_Poland.svg',
            title: 'Польська мова A2 — впевнене просування вперед!',
            description:
                'Якщо ти вже опанував основи польської (A1) і хочеш впевненіше висловлювати свої думки, розуміти мову на слух та будувати складніші речення — цей курс для тебе!',
            numberOfLessons: '22',
            duration: '2 місяці',
            price: '599 zł',
            link1: '/courses#polish-a2',
            link2: '/contact',
        },
        {
            img: '/svg/Flag_of_Poland.svg',
            title: 'Польська мова B1 — впевнене володіння мовою!',
            description:
                'Цей курс для тих, хто вже володіє польською на рівні A2 і хоче вийти на новий рівень — навчитися вільно висловлювати думки, дискутувати та краще розуміти носіїв мови.',
            numberOfLessons: '22',
            duration: '2 місяці',
            price: '599 zł грн',
            link1: '/courses#polish-b1',
            link2: '/contact',
        },
        {
            img: '/svg/Flag_of_Poland.svg',
            title: 'Польська мова B2 — шлях до вільного мовлення!',
            description:
                'Курс B2 відкриває перед тобою двері до справжнього двомовного життя — з польською мовою як інструментом впевненого самовираження. Приєднуйся!',
            numberOfLessons: '22',
            duration: '1.5 місяці',
            price: '599 zł грн',
            link1: '/courses#polish-b2',
            link2: '/contact',
        },
    ];

    return (
        <>
            <Splide
                aria-label="Courses slider"
                options={{
                    perPage: 3 ,
                    width: '100%',
                    autoWidth: true,
                    autoHeight: true,
                    pagination: true,
                    arrows: true,
                    gap: 16,
                    rewind: true,
                    breakpoints: {
                        767: {
                            perPage: 1,
                            arrows: false,
                            rewind: true,
                            focus: 'center',

                        },
                    }
                }}
            >
                {courseItems.map((item, index) => (
                    <SplideSlide key={index}>
                        <div className="course-item">
                            <div className="course-item__title">
                                <Image src={item.img} width={64} height={64} alt="" />
                                <p>{item.title}</p>
                            </div>
                            <div className="course-item__description">
                                <p>{item.description}</p>
                            </div>
                            <div className="course-item__number-of-lessons">
                                <p>Кількість уроків: {item.numberOfLessons}</p>
                            </div>
                            <div className="course-item__duration">
                                <p>Тривалість: {item.duration}</p>
                            </div>
                            <div className="course-item__price">
                                <p>Ціна: {item.price}</p>
                            </div>

                            <div className="course-item__btn">
                                <Link href={item.link1}>
                                    <button
                                        className="course-item__btn--learn-more"
                                        onClick={() => handleLearnMoreClick(item.title)}
                                    >
                                        Дізнатись більше
                                    </button>
                                </Link>
                                <Link href={item.link2}>
                                    <button
                                        className="course-item__btn--enroll"
                                        onClick={() => handleEnrollClick(item.title)}
                                    >
                                        Записатись
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </SplideSlide>
                ))}
            </Splide>
        </>
    );
};

export default CourseItems;
